import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { selectConfig } from 'src/app/utils/utils';
import { forkJoin, Observable } from 'rxjs';
import { ClientService } from 'src/app/services/client-services/clients.service';
import { DealsService } from 'src/app/services/deals.service';
import { EmailClientService } from 'src/app/services/integrations/email/email-client.service';
import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-edit-filter-task',
  templateUrl: './edit-filter-task.component.html',
  styleUrls: ['./edit-filter-task.component.css']
})
export class EditFilterTaskComponent implements OnInit {
  user;
  @Input() filterIndex;
  @Input() filterData;
  @Output() cancelFiter = new EventEmitter();
  @Output() getEditFilter = new EventEmitter();
  editLoading = false;
  supervisorAttachedUsers;
  clientListFilter2;
  salesperson_config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Salesperson", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search salesperson",
    displayKey: 'fullName',
  };
  Clientconfig = { ...selectConfig, placeholder: 'Search Client', noResultsFound: "Type here to search" };
  Dealconfig = { ...selectConfig, placeholder: 'Search Deal', noResultsFound: "Client Has No Deal" };
  dealList$: Observable<any>;
  clientFilterID;
  deal;

  editFilterForm = new FormGroup({
    id: new FormControl(''),
    name: new FormControl('', [Validators.required, noWhitespaceValidator]),
    type: new FormControl(''),
    status: new FormControl(''),
    userID: new FormControl(''),
    clients: new FormControl(''),
    deals: new FormControl(''),
  })

  constructor(
    private clientSrv: ClientService,
    store: Store<AppState>,
    private dealServ: DealsService,
    private signupSrv: SignupLoginService,
    private emailClientService: EmailClientService,
  ) {
    store.select("userInfo").subscribe(info => {
      this.user = info.user
    });
  }

  ngOnInit() {
    this.fetchUsersBySupervisor();
  }

  setValue() {
    const filter = this.filterData;
    const selectedUser = this.supervisorAttachedUsers.find(sup => sup.id == filter.userID );    
    let data = {
      ...filter,
      userID: selectedUser
    };
    if (filter.clients && filter.clients.id) {
      data = { ...data, clients: { id: filter.clients.clientID, name: filter.clients.clientName } }
    } else {
      data = { ...data, clients: null }
    }
    if (filter.deals && filter.deals.code) {
      data = { ...data, deals: { code: filter.deals.dealCode, name: filter.deals.dealName } }
    } else {
      data = { ...data, deals: null }
    }
    this.editFilterForm.patchValue(data);
    // this.getClientDeals();

  }

  toString(value) {
    return JSON.stringify(value);
  }

  cancel() {
    this.cancelFiter.emit(this.filterIndex);
  }

  editFilter() {
    const data = { ...this.filterData, ...this.editFilterForm.value };
    this.getEditFilter.emit(data);
  }

  //important
  /**
  * Fetch users attached to a supervisor
  */
  fetchUsersBySupervisor() {
    const getSurbodinates = this.signupSrv.fetchTaskSubordinates(this.user.email).pipe(map(subs => {
      const res = subs.filter((person) => person.salesPerson == "true");
      const result = res.concat(this.user);
      return result.map(sub => ({
        id: `${sub.id}`,
        salesPerson: `${sub.salesPerson}`,
        fullName: `${sub.firstName} ${sub.lastName}`
      }))
    }));
    forkJoin([getSurbodinates]).subscribe(responses => {
      this.supervisorAttachedUsers = responses[0];
      this.setValue();
    });
  }

  clientLookUp2(value) {
    if (value.length <= 0 || value == undefined || !value) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    this.editFilterForm.patchValue({ dealFilter: '' });
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const client_lookup = this.clientSrv.getClientWildcard(value);
    forkJoin([leads_lookup, client_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        this.clientListFilter2 = [...lookUp];
      })

  }

  getClientDeals() {
    const clientInfo = this.editFilterForm.value.clients;
    this.dealList$ = this.dealServ.getAllContactDeals("client", clientInfo.id)
  }

  clearSuggestedUsers() {
    this.clientListFilter2 = [];
  }

}
